import {
  FloatButton as AntdFloatButton,
  FloatButtonProps as AntdFloatButtonProps,
} from "antd";
import React from "react";

type FloatButtonProps = AntdFloatButtonProps & {
  label?: string; // Optional label for tooltips
};
const FloatButton = ({ label, ...rest }: FloatButtonProps) => {
  return <AntdFloatButton tooltip={label ? label : undefined} {...rest} />;
};
export default FloatButton;

FloatButton.Group = AntdFloatButton.Group;
